import { UpdateDocumentBar } from "@app/pages/Editor/UpdateDocumentBar";
import { DocumentVersionStatus } from "@generated/client/graphql";
import { useTranslation } from "react-i18next";
import { useEditorContext } from "../hooks/useEditor";

export default function TopLeftBlock() {
    const { version } = useEditorContext();
    const { t } = useTranslation("EditDocument");
    if (!version || version.status === DocumentVersionStatus.Approved)
        return null;
    return (
        <UpdateDocumentBar
            buttonLabel={t("update_bar_button_label")}
            description={t("update_bar_description")}
        />
    );
}
